import React, { useState } from 'react'
import InputField from './ui/InputField'
import FormButton from './ui/FormButton';
import { createMission } from '../services/api/missions/createMission';

const MissionForm = () => {
  const initData = { title:"" };
  const [data, setData] = useState(initData);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name,value } = e.target;
    setData(prev => ({...prev,[name]: value}));
  };

  const handleClear = () => {
    setData(initData);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (data.title.trim().length !== 0) {
      setIsLoading(true);
      createMission(data.title).then(response => {
        if (!(response.error === null)) {
          alert('an error');
        }else{
          alert('mission created');
        }
      }).finally(() => {
        setIsLoading(false);
        handleClear();
      });
    }else{
      alert('fill all the details');
    }
  };
 
  return (
    <div className='flex justify-center'>
    <form method='POST' className='flex flex-col gap-4 min-w-full sm:min-w-[650px] sm:max-w-[650px]' onSubmit={handleSubmit}>
        <p className='text-lg font-semibold text-blue-500 text-center'>Create a new Mission</p>
    <InputField
        label="Mission Title"
        name="title"
        value={data.title}
        onChange={handleChange}
        required={true}
        placeholder="Enter a mission title"
      />
    <FormButton
        label={isLoading ? 'Creating...' : 'Create Mission'}
        type={'submit'}
        disabled={isLoading}
      />
    </form>
    </div>
  )
}

export default MissionForm

